import { Inbox, Send, FileText, Clock, Trash2, PenSquare } from 'lucide-react'
import { cn } from '../../lib/utils'
import { DropdownSelect } from '../../components/ui/DropdownSelect'

type Folder = 'inbox' | 'sent' | 'drafts' | 'scheduled' | 'trash'
interface EmailAccount { id: string; name: string; fromAddress: string }
interface Props {
  folder: Folder
  onFolder: (f: Folder) => void
  onCompose: () => void
  accounts: EmailAccount[]
  selectedAccount: string | undefined
  onAccount: (id: string | undefined) => void
  inboxCount?: number
  scheduledCount?: number
}

const BASE_FOLDERS: { id: Folder; label: string; Icon: React.ElementType }[] = [
  { id: 'inbox',  label: 'Inbox',   Icon: Inbox },
  { id: 'sent',   label: 'Sent',    Icon: Send },
  { id: 'drafts', label: 'Drafts',  Icon: FileText },
  { id: 'trash',  label: 'Trash',   Icon: Trash2 },
]

export function FolderColumn({ folder, onFolder, onCompose, accounts, selectedAccount, onAccount, inboxCount, scheduledCount }: Props) {
  return (
    <div className="w-40 flex-shrink-0 border-r border-gray-200 bg-gray-50 flex flex-col">
      <div className="p-3">
        <button onClick={onCompose} className="w-full flex items-center justify-center gap-2 bg-primary-600 text-white text-sm font-semibold py-2 px-3 rounded-full hover:bg-primary-700 transition-colors">
          <PenSquare className="w-3.5 h-3.5" /> Compose
        </button>
      </div>

      {accounts.length > 1 && (
        <div className="px-3 pb-2">
          <DropdownSelect
            value={selectedAccount ?? ''}
            onChange={v => onAccount(v || undefined)}
            placeholder="All accounts"
            options={[{ value: '', label: 'All accounts' }, ...accounts.map(a => ({ value: a.id, label: a.name }))]}
            buttonClassName="text-xs"
          />
        </div>
      )}

      <nav className="flex-1 px-2 space-y-0.5">
        {BASE_FOLDERS.map(({ id, label, Icon }) => (
          <button key={id} onClick={() => onFolder(id)}
            className={cn('w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-left transition-colors',
              folder === id ? 'bg-primary-100 text-primary-700 font-semibold' : 'text-gray-600 hover:bg-gray-100')}>
            <Icon className="w-4 h-4 flex-shrink-0" />
            <span className="flex-1">{label}</span>
            {id === 'inbox' && (inboxCount ?? 0) > 0 && (
              <span className="text-xs bg-primary-600 text-white rounded-full px-1.5 py-0.5 font-bold">{inboxCount}</span>
            )}
          </button>
        ))}
        {(scheduledCount ?? 0) > 0 && (
          <button onClick={() => onFolder('scheduled')}
            className={cn('w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-left transition-colors',
              folder === 'scheduled' ? 'bg-primary-100 text-primary-700 font-semibold' : 'text-gray-600 hover:bg-gray-100')}>
            <Clock className="w-4 h-4 flex-shrink-0" />
            <span className="flex-1">Scheduled</span>
            <span className="text-xs bg-amber-500 text-white rounded-full px-1.5 py-0.5 font-bold">{scheduledCount}</span>
          </button>
        )}
      </nav>
    </div>
  )
}
